module.exports = __webpack_public_path__ + "static/media/linea_3.504e5735.svg";